import React, { FC } from 'react';
import { SelectProps, Tag } from 'antd';
import { useHandbook } from '~/controllers/handbook';
import Select from './Select';

type TagRender = SelectProps['tagRender'];

const RolesSelect: FC<SelectProps<string>> = (props) => {
  const { value } = props;
  const handbook = useHandbook();
  const options = handbook.data?.handbooks
    ?.find((item) => item.key === 'roles')
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ?.values?.map((item) => ({ label: item.localizedValue, value: item.apiValue!, key: item.key }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const tagRender: TagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        // color={value}

        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginInlineEnd: 6, height: 30, paddingTop: 3, margin: 7, fontSize: '14px' }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <Select
      mode="tags"
      loading={handbook.isLoading}
      disabled={handbook.isLoading}
      showSearch
      size="large"
      options={options}
      {...props}
      defaultValue={value}
      tagRender={tagRender}
    />
  );
};

export default RolesSelect;
